import { useTranslation } from "react-i18next";
import "../../styles/homePage/genericForm.scss";
import PropertySegment from "./general/PropertySegment";

export interface InfoFieldsBuilderInterface {
  title: string;
  textArray: string[];
  offset?: string;
  className?: string;
  translateOffset?: boolean;
  colWidth?: string;
  nested?: number;
  fullRow?: boolean;
  translate?: boolean;
  customPropertySegmentClassName?: string;
  checkMetric?:boolean;
  metric?:string;
  suffix?: string;
}

interface InfoFieldsBuilderProps {
  fields: InfoFieldsBuilderInterface[];
  containerClassName?: string;
  formContainerClassName?: string;
  metric?:string
}

const InfoFieldsBuilder = (props: InfoFieldsBuilderProps) => {
  const { fields, containerClassName, formContainerClassName ,metric} = props;
  const { t } = useTranslation();

  return (
    <div className={`generic-form ${formContainerClassName}`}>
      <div className={`info-fields-grid ${containerClassName}`}>
        {fields.map((field, i) => (
          !field.checkMetric || (field.checkMetric && field.metric === metric) ?
          <div
            className={`info-field-item ${field.nested ? "has-nested" : ""} ${
              field.offset ? `offset-${field.offset}` : ""
            } ${field.fullRow ? "full-row" : ""} ${
              field.translateOffset ? "translate-offset" : ""
            } ${field.colWidth || ""}`}
            key={`${field.title}${i}`}
          >
            <PropertySegment
              title={field?.translate ? t(field.title) : field.title}
              textArray={field.textArray}
              suffix={field.suffix}
              className={`${field?.customPropertySegmentClassName} ${
                field.offset ? `offset-${field.offset}` : ""
              } ${field.translateOffset ? "translate-offset" : ""}`}
            />
          </div>
          :null
        ))}
      </div>
    </div>
  );
};

export default InfoFieldsBuilder;
